import { GalleryHookConfig } from "./types";

export const getGalleryConfig = (
  type: string | undefined,
  hooksMap: Record<string, GalleryHookConfig>,
): GalleryHookConfig | null => {
  return type ? hooksMap[type] || null : null;
};
